// DO NOT EDIT: autogenerated by brokkr

const borderWidths = {
  xs: "0.05rem",
  sm: "0.0625rem",
  md: "0.125rem",
};

export default borderWidths;
